module.exports = __webpack_public_path__ + "static/media/undo.b856d121.svg";